<template>
  <div>
    <div class="column">
      <!-- 利用区間-->
      <BFaceSectionDisp v-if="book.price" :price="book.price" :displaySectionType="pass.display_section_type"
        :isReturnTrip="pass.is_return_trip" />
    </div>

    <div class="column">
      <!-- division毎の購入枚数の表示 -->
      <BgFaceDivisionCountDisp :divisions="divisions" />
    </div>

    <!-- 有効期間-->
    <div class="column">
      <!-- 有効化前 開始〜終了期間 -->
      <div v-if="pass.is_valid == false">
        <BFaceAvailablePeriodDisp v-if="book.user_started_at" :start="book.user_started_at"
          :limit="limitedAtMinusStartHour" />
        <!-- book.user_started_atがない場合、book.available_started_atを使用 -->
        <BFaceAvailablePeriodDisp v-else :start="book.available_started_at" :limit="limitedAtMinusStartHour" />
      </div>

      <!-- 有効化後 -->
      <div v-else>
        <!-- 開始〜終了期間 -->
        <BFaceAvailablePeriodDisp v-if="!isCountdownType" :start="pass.user_started_at"
          :limit="limitedAtMinusStartHour" />

        <!-- 利用期限(カウントダウン表示する一部チケットのみ) -->
        <PFaceUseEndPeriod v-else :limit="pass.user_limited_at" />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import bookGroupService from "@/services/bookGroup";
import myTicketsCommonService from "@/services/common/myTickets";
import passService from "@/services/pass";

export default {
  name: "ThePassUpper",
  props: {
    headerTitle: {
      type: String,
      required: false,
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const divisions = ref([]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const pass = computed(() => store.getters["ticketing/pass"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const masterPass = computed(() => store.getters["ticketing/masterPass"]);

    const isCountdownType = computed(() => passService.checkIsCountdownPass(masterPass.value));

    const limitedAtMinusStartHour = computed(() => {
      // 有効化前でbook.user_XXX_atがある場合
      if (!pass.value.is_valid && book.value.user_started_at) {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.user_limited_at,
          masterBook.value.start_hour
        );
        // 有効化前でbook.user_XXX_atがない場合
      } else if (!pass.value.is_valid && !book.value.user_started_at) {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.available_limited_at,
          masterBook.value.start_hour
        );
        // 有効化後
      } else {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          pass.value.user_limited_at,
          masterBook.value.start_hour
        );
      }
    });

    onMounted(() => {
      divisions.value = bookGroupService.divisionArrange(
        bookGroup.value.books
      );
    });

    return {
      divisions,
      book,
      pass,
      masterBook,
      isCountdownType,
      limitedAtMinusStartHour,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
